import { useIsAuthenticated } from "@azure/msal-react";
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, IconButton, Toolbar } from '@mui/material';
import { motion } from 'framer-motion';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from "../AppContext";
import HeaderMenu from "./HeaderMenu";
import HeaderMobile from './HeaderMobile';
import Login from './LoginMenu';
import { useUnifiedAuthentication } from "../components/CommonComponents";

import './styles/Header.css';
const AnimatedMenuIcon = motion(MenuIcon);

const Header = () => {
    const isAuthenticated = useUnifiedAuthentication();
    const { menuItems, embeddingData } = useContext(AppContext);
    const navigate = useNavigate();
    const [toolbarMargins, setToolbarMargins] = useState({ marginLeft: '170px', marginRight: '170px' });
    const [logoMarginRight, setLogoMarginRight] = useState('auto'); // State for logo marginRight
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1300);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1300);

            let newMargins = { marginLeft: '170px', marginRight: '170px' };
            let newLogoMarginRight = 'auto';

            if (window.innerWidth > 2500) {
                newMargins = { marginLeft: '240px', marginRight: '240px' };
                newLogoMarginRight = '60%'
            }
            else if (window.innerWidth > 2800) {
                newMargins = { marginLeft: '320px', marginRight: '320px' };
                newLogoMarginRight = '40%'
            }
            else if (window.innerWidth > 3000) {
                newMargins = { marginLeft: '390px', marginRight: '390px' };
                newLogoMarginRight = '20%'
            }
            setToolbarMargins(newMargins);
            setLogoMarginRight(newLogoMarginRight); 
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const styles = {
        header: {
            backgroundColor: !isAuthenticated ? 'transparent' : '#00594d',
            zIndex: 4,
            boxShadow: 'none',
            borderBottom: isAuthenticated ? '2px solid white' : '',
        },
        toolbar: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: toolbarMargins.marginLeft, 
            marginRight: toolbarMargins.marginRight, 
            minHeight: 'auto',
        },
        logoButton: {
            maxHeight: '50px',
            height: '40px',
            width: 'auto',
            opacity: 1,
            zIndex: 4
        },
        menuItems: {
            display: 'flex',
            gap: '20px',
        },
        menuLink: {
            color: 'white',
            textDecoration: 'none',
            fontWeight: '700',
            fontSize: '16px',
            textTransform: 'uppercase' as 'uppercase',
            fontFamily: "'Barlow', sans-serif",
            zIndex: 4,
            letterSpacing: 'normal',
        },
        languageSelector: {
            fontSize: '14px',
            color: 'white',
        },
        languageLink: {
            color: 'inherit',
            textDecoration: 'none',
            cursor: 'pointer',
        },
    };

    const menuIconStyles = isAuthenticated ? {
        color: 'white',
        height: "100%",
        ml: "9px",
        mr: "9px",
        cursor: 'pointer',
        outline: 'none'
    } : {
        color: '#0d4557',
        height: "100%",
        ml: "9px",
        mr: "9px",
        cursor: 'pointer',
        outline: 'none'
    }

    return (
        !isMobile ? (
            <AppBar position="fixed" style={styles.header}>
                <Toolbar style={styles.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="logo"
                        sx={{
                            marginRight: logoMarginRight
                        }}
                        onClick={() => {
                            navigate("/reports/" + embeddingData?.pageLoadReportId);
                        }}
                    >
                        <img
                            src="https://travelheartfamily.com/wp-content/uploads/2023/09/THF-LOGO-LOGOTYPE-neg.svg"
                            alt="Travelheart Family"
                            width="0"
                            height="0"
                            style={styles.logoButton}
                        />
                    </IconButton>
                    {isAuthenticated &&
                        <HeaderMenu items={menuItems} />
                    }
                    <Login />
                </Toolbar>
            </AppBar>) : <HeaderMobile items={menuItems} />
    );
};

export default Header;